import React from "react";
import SchoolLogo from "./SchoolLogo";

/**
 * Printable / shareable school-branded QR card.
 * Used in member self-service and in the org-admin member modal.
 */
export default function QRPrintCard({
  qrCanvasId = "printable-qr-canvas",
  qrValue,
  memberName,
  memberCode,
  organizationName,
  size = 220,
  QRComponent,
}) {
  return (
    <div
      className="printable bg-white rounded-lg border border-[#D2D8D4] p-6 max-w-sm w-full"
      data-testid="qr-print-card"
    >
      <div className="flex items-center gap-3 pb-4 border-b border-[#E3E6E4]">
        <SchoolLogo size={48} />
        <div className="leading-tight">
          <div className="text-[9px] font-bold uppercase tracking-[0.22em] text-[#05126E]">
            Attendance System
          </div>
          <div className="font-extrabold text-[#0f1a14] text-sm">
            GANAP INC.
          </div>
        </div>
      </div>

      <div className="mt-5 flex flex-col items-center text-center">
        <div className="bg-white p-3 border border-[#D2D8D4] rounded-md">
          {QRComponent ? (
            <QRComponent id={qrCanvasId} value={qrValue} size={size} level="H" includeMargin />
          ) : null}
        </div>
        {memberCode ? (
          <div className="mt-3 inline-block px-2.5 py-1 rounded-md bg-[#E6E9F5] border border-[#05126E]/30">
            <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#05126E]">
              Member ID
            </span>{" "}
            <span className="mono text-sm font-bold text-[#0f1a14]">{memberCode}</span>
          </div>
        ) : null}
        <div className="mt-3">
          <div className="text-[9px] font-bold uppercase tracking-[0.22em] text-[#5a6663]">
            Member name
          </div>
          <div className="text-lg font-extrabold text-[#0f1a14] tracking-tight">
            {memberName}
          </div>
        </div>
        {organizationName ? (
          <div className="mt-2">
            <div className="text-[9px] font-bold uppercase tracking-[0.22em] text-[#5a6663]">
              Organization
            </div>
            <div className="text-sm font-semibold text-[#0f1a14]">
              {organizationName}
            </div>
          </div>
        ) : null}
      </div>

      <div className="mt-5 pt-4 border-t border-[#E3E6E4] text-center">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#5a6663]">
          For attendance scanning only
        </div>
      </div>
    </div>
  );
}
